import React, { useContext } from 'react';
import './App.scss';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import Header from './components/header/Header';
import HeroSection from './components/HeroSection';
import FeatureSection from './components/FeatureSection';
import Footer from './components/footer/Footer';
import UserSettingsPage from './pages/UserSettingsPage';
import GroceryListPage from './pages/GrocerListPageC';
import BlogRecipePage from './pages/BlogRecipePage';
import RecipeGenerator from './pages/RecipeGenerator';
import RecipeList from './pages/RecipeList';
import MealPlannerPage from './pages/UserSettingsPage';
import SignInPagePage from './components/SignInPage';
import SignupPage from './components/SignupPage';
import ConfirmEmailPage from './components/ConfirmEmailPage';
import ForgotPasswordPage from './components/ForgotPasswordPage';
import ResetPasswordPage from './components/ResetPasswordPage';
import FAQPage from './pages/FAQPage';
import EditBlogRecipePage from './pages/EditBlogRecipePage'; // Import the new EditBlogRecipePage
import { AuthContext, AuthProvider } from './components/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import { UserProvider } from './context/UserContext';
import { AppCacheProvider } from './context/AppCacheContext';
import { useNavigate } from 'react-router-dom';
import TermsOfServicePage from './pages/TermsOfServicePage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import FeedbackPage from './pages/FeedbackPage';
import CookiePolicyPage from './pages/CookiePolicyPage';
import LocalFlavorsPage from './pages/LocalFlavorsPage';


// Component to determine if the menu should be hidden
const AppWithHeader: React.FC = () => {
  const location = useLocation();
  const { isAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();

  // Check if the user is trying to access a protected route and is not authenticated
  if (!isAuthenticated && [ '/edit-blog-recipe/:id', '/user-settings', '/grocery',  '/meal-planner'].includes(location.pathname)) {
    return <Navigate to="/login" replace />;
  }

  const hideMenu = ['/login', '/signup', '/forgot-password', '/reset-password', '/confirm-email'].includes(location.pathname);

  const handleLoginSuccess = () => {
    // Define what happens after login succeeds
    console.log('User successfully logged in');
    navigate('/');
  };

  return (
    <div className="App">
      <Header hideMenu={hideMenu} />
      <Routes>
        <Route path="/" element={<HeroSection />} />
        <Route path="/features" element={<FeatureSection />} />
        <Route path="/login" element={<SignInPagePage onSuccess={handleLoginSuccess} />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/confirm-email" element={<ConfirmEmailPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />

        {/* New Routes for Blog and Recipe Pages */}
        <Route
          path="/recipe/:recipeId"
          element={

              <BlogRecipePage/>
          }
        />
        <Route
          path="/edit-blog-recipe/:id"
          element={
            <ProtectedRoute>
              <EditBlogRecipePage />
            </ProtectedRoute>
          }
        />

        {/* Protected Routes */}
        <Route
          path="/user-settings"
          element={
            <ProtectedRoute>
              <UserSettingsPage onCancel={() => {}} onSave={() => {}} />
            </ProtectedRoute>
          }
        />
       
        <Route
          path="/generate"
          element={
              <RecipeGenerator  />
          }
        />

      <Route
          path="/cookies"
          element={
              <CookiePolicyPage  />
          }
        />

      <Route
          path="/terms"
          element={
              <TermsOfServicePage  />
          }
        />
        

    <Route
          path="/privacy"
          element={
              <PrivacyPolicyPage  />
          }
        />



        <Route
          path="/faq"
          element={
              <FAQPage  />
          }
        />

      <Route
          path="/recipes"
          element={
              <RecipeList  />
          }
        />
       
       <Route
          path="/localflavors"
          element={
              <LocalFlavorsPage  />
          }
        />


       <Route
          path="/grocery"
          element={
            <ProtectedRoute>
              <GroceryListPage />
            </ProtectedRoute>
          }
        />
        <Route path="/feedback" element={<FeedbackPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Footer />
    </div>
  );
};

const App: React.FC = () => {
  return (
    <AppCacheProvider>
      <UserProvider>
        <AuthProvider>
        <Router>
          <AppWithHeader />
        </Router>
        </AuthProvider>
      </UserProvider>
    </AppCacheProvider>
  );
};

export default App;
